import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { ColDef, ExcelExportParams, GridApi, GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
@Component({
  selector: 'app-three-sixty-dashboard-popups',
  templateUrl: './three-sixty-dashboard-popups.component.html',
  styleUrls: ['./three-sixty-dashboard-popups.component.scss'],
})
export class ThreeSixtyDashboardPopupsComponent implements OnInit {
  isToggleChecked: boolean = false;
  loggedInUserCompanyID: any;
  selectedYear: any;
  stakeholders: any = [];
  // isComplete: boolean = false;
  counterListData: any = [];
  reviewId: any
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ThreeSixtyDashboardPopupsComponent>, private encryptionService: EncryptionService, public router: Router, private activatedroute: ActivatedRoute,
    public dialog: MatDialog, public sharedService: SharedService,
    private loader: LoaderService,
    private httpService: HttpService, private config: Config, private fb: FormBuilder,
    private datePipe: DatePipe, public mobileResponsiveService: MobileResponsiveService) {
    console.log(data.stakeHoldersArrayForSetup)
    this.reviewId = data.selectedReviewGlobalDashboardID;
    this.stakeholders = data.stakeHoldersArrayForSetup
  }

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.selectedYear = this.data.selectedYear;
    this.get360CounterPopUp();
    this.initializeThreeSixtyColumns()
  }





  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = false;
  paginationPageSize = 10000000;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };

  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      minWidth: 80,

      // ✅ add this
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: 'single',
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });

  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
    console.log(params)
  }
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');

  }

  onBtExport(strMsg: any) {
    const params: ExcelExportParams = {
      fileName: strMsg + '_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: strMsg,
      exportAsExcelTable: {
        showRowStripes: true,
        name: strMsg
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['startDate', 'endDate']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // capitalize each word
        }

        return value;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  }



  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {

    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

  // Helper function to convert any date string into dd-MM-yyyy
  formatDateOnly(dateStr: string | null): string | null {
    if (!dateStr) return null;

    let datePart = dateStr;
    if (dateStr.includes('T')) {
      datePart = dateStr.split('T')[0];
    }

    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;

    // Date object 
    const date = new Date(y, m - 1, d);

    // Format dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;


  resetGrid() {
    this.isClicked = true; // Trigger animation

    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }
  // --------------------------------AG GRID CODE---------------------------------------------------------

  // ----------------Start----------------------

  getNoOfFieldName(name: string): string {
    switch (name) {
      case 'Self':
        return 'noOfSelf';
      case 'Superior':
        return 'noOfSuperior';
      case 'Peer':
        return 'noOfPeer';
      case 'Subordinate':
        return 'noOfSubordinate';
      case 'Internal Customer':
        return 'noOfInternalCustomer';
      case 'External Customer':
        return 'noOfExternalCustomer';
      default:
        return '';
    }
  }
  stakeholderColumns: ColDef[] = this.stakeholders
    ?.filter((s: any) => s.selected)
    .map((s: any) => ({
      headerName: `Score by ${s.name} (${s.weightage})`,
      field: this.getNoOfFieldName(s.name),
      minWidth: 220,
      filter: 'agSetColumnFilter',
      cellStyle: { textAlign: 'center' },

      onCellClicked: (params: any) => {
        if (typeof params.value === 'string' && params.value.trim() !== '') {
          params.context.componentParent.openCommentModal(
            params.value,
            `Score by ${s.name} (${s.weightage})`
          );
        }
      },
    }));
  // threeSixtyColumnDefs: ColDef[] = [
  //   {
  //     headerName: 'Start Date',
  //     field: 'startDate',
  //     cellRenderer: (params: any) => this.dateRenderer(params),
  //     comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
  //     filter: 'agDateColumnFilter',
  //     minWidth: 150,
  //     filterParams: {
  //       filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
  //       suppressAndOrCondition: true,  // ✅ AND/OR hide
  //       maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
  //     }
  //   },
  //   {
  //     headerName: 'End Date',
  //     field: 'endDate',
  //     cellRenderer: (params: any) => this.dateRenderer(params),
  //     comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
  //     filter: 'agDateColumnFilter',
  //     minWidth: 150,
  //     filterParams: {
  //       filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
  //       suppressAndOrCondition: true,  // ✅ AND/OR hide
  //       maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
  //     }
  //   },
  //   { headerName: 'Name of 360 Review', field: 'reviewName',minWidth: 210 , filter: 'agSetColumnFilter' },
  //   { headerName: 'No. of self', field: 'noOfSelf',minWidth: 150 , filter: 'agSetColumnFilter' },
  //   { headerName: 'No. of peers', field: 'noOfPeer',minWidth: 150 , filter: 'agSetColumnFilter'},
  //   { headerName: 'No. of subordinates', field: 'noOfSubordinate',minWidth: 210 , filter: 'agSetColumnFilter' },
  //   { headerName: 'No. of superior', field: 'noOfSuperior',minWidth: 170 , filter: 'agSetColumnFilter' },
  //   { headerName: 'No. of internal customer', field: 'noOfInternalCustomer',minWidth: 230 , filter: 'agSetColumnFilter' },
  //   { headerName: 'No. of external customer', field: 'noOfExternalCustomer',minWidth: 230 , filter: 'agSetColumnFilter' },
  //   { headerName: 'Total Employee', field: 'noOfTotalEmployee',minWidth: 175 , filter: 'agSetColumnFilter' },

  //   // Conditional column (Completed / Incompleted)
  //   {
  //     headerName: 'Completed',
  //     field: 'noOfCompleted',
  //     minWidth: 170 , filter: 'agSetColumnFilter',
  //     hide: !this.isToggleChecked
  //   },
  //   {
  //     headerName: 'Incompleted',
  //     field: 'noOfIncompleted',
  //     minWidth: 170 , filter: 'agSetColumnFilter',
  //     hide: this.isToggleChecked
  //   }
  // ];

  threeSixtyColumnDefs!: ColDef[];
  initializeThreeSixtyColumns(): void {
    const stakeholderColumns: ColDef[] = this.stakeholders
      ?.filter((s: any) => s.selected)
      .map((s: any) => ({
        headerName: `Score by ${s.name} (${s.weightage})`,
        field: this.getNoOfFieldName(s.name),
        minWidth: 220,
        filter: 'agSetColumnFilter',
        cellStyle: { textAlign: 'center' },
        onCellClicked: (params: any) => {
          if (typeof params.value === 'string' && params.value.trim() !== '') {
            params.context.componentParent.openCommentModal(
              params.value,
              `Score by ${s.name} (${s.weightage})`
            );
          }
        },
      }));

    this.threeSixtyColumnDefs = [
      {
        headerName: 'Start Date',
        field: 'startDate',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 150,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,
          maxNumConditions: 1
        }
      },
      {
        headerName: 'End Date',
        field: 'endDate',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 150,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,
          maxNumConditions: 1
        }
      },
      { headerName: 'Name of 360 Review', field: 'reviewName', minWidth: 210, filter: 'agSetColumnFilter' },

      // ✅ Add dynamic stakeholder score columns here
      ...stakeholderColumns,
      { headerName: 'Total Employee', field: 'noOfTotalEmployee', minWidth: 175, filter: 'agSetColumnFilter' },
      // ✅ Conditional columns
      {
        headerName: 'Completed',
        field: 'noOfCompleted',
        minWidth: 170,
        filter: 'agSetColumnFilter',
        hide: !this.isToggleChecked
      },
      {
        headerName: 'Incompleted',
        field: 'noOfIncompleted',
        minWidth: 170,
        filter: 'agSetColumnFilter',
        hide: this.isToggleChecked
      }
    ];
  }


  toggleChanged() {
    this.threeSixtyColumnDefs = this.threeSixtyColumnDefs.map(col => {
      if (col.field === 'noOfCompleted') {
        return { ...col, hide: !this.isToggleChecked };
      }
      if (col.field === 'noOfIncompleted') {
        return { ...col, hide: this.isToggleChecked };
      }
      return col;
    });

    // 👇 Grid ko refresh karna zaroori hai
    if (this.gridApi) {
      this.gridApi.setColumnDefs(this.threeSixtyColumnDefs);
    }
  }

  showColumn(col: any): boolean {
    // Agar toggle ON hai to "Completed" dikhao, Incompleted mat dikhao
    if (this.isToggleChecked && col.field === 'noOfIncompleted') {
      return false;
    }

    // Agar toggle OFF hai to "Incompleted" dikhao, Completed mat dikhao
    if (!this.isToggleChecked && col.field === 'noOfCompleted') {
      return false;
    }

    // Baaki sab column always visible
    return true;
  }


  // -----------------End------------------------

  get360CounterPopUp() {
    const year = this.selectedYear?.split('-');
    const request = {
      "band": null,
      "companyId": this.loggedInUserCompanyID,
      "competencyId": [],
      "fromYear": year[0],
      "isComplete": this.isToggleChecked,
      "isTopAnalysis": false,
      "reviewId": null,
      "toYear": year[1],
      "userId": null
    }
    this.httpService.callPostService(this.config.get360CounterPopUp, request).subscribe((res: any) => {
      console.log(res.data);

      this.counterListData = res?.data.filter((e: any) => e.reviewId == this.reviewId) || [];
      
    })
  }
  isDownload: boolean = true;
  onClickDownloadScoresOfSurveys(id: any) {
    const flattenedData: any[] = [];
    this.counterListData.forEach((ele: any) => {
      flattenedData.push({
        "Start Date": this.datePipe.transform(ele.startDate, "dd/MM/yyyy"),
        "End Date": this.datePipe.transform(ele.endDate, "dd/MM/yyyy"),
        "Name of 360 Review": ele.reviewName,
        "No. of self": ele.noOfSelf,
        "No. of peers": ele.noOfPeer,
        "No. of subordinates": ele.noOfSubordinate,
        "No. of superior": ele.noOfSuperior,
        "No. of internal customer": ele.noOfInternalCustomer,
        "No. of external customer": ele.noOfExternalCustomer,
        "Total Employee": ele.noOfTotalEmployee,
        "Completed": ele.noOfCompleted,
        "Incompleted": ele.noOfIncompleted,
      });
    });
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
    const fileName = '360_degree_created_by_HR' + formattedDate + '.xlsx';
    saveAs(data, fileName);
    this.isDownload = true;
    this.loader.dismissLoader()
  }
}
